import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b7d4d5fc&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7d4d5fc')) {
      api.createRecord('b7d4d5fc', component.options)
    } else {
      api.reload('b7d4d5fc', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b7d4d5fc&", function () {
      api.rerender('b7d4d5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-81wW50y6v8Ddq/JS/imageCarousel.vue"
export default component.exports